import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import InteractionGuard from '../components/guards/InteractionGuard';

type VideoResult = { job_id?: string; status?: string } | null;

export default function Video() {
  const { isAuthenticated } = useAuth();
  // TODO: Implement text-to-video generation hook
  // For now, using stub values
  const generateVideo = (_options: { prompt: string; model: string; duration: number }) => {
    console.warn('Text-to-video generation not yet implemented');
  };
  const loading = false;
  const error: string | null = null;
  const result: VideoResult = null;
  const [prompt, setPrompt] = useState('');
  const [showGuard, setShowGuard] = useState(false);

  const handleGenerate = () => {
    if (!isAuthenticated) {
      setShowGuard(true);
      return;
    }

    if (!prompt.trim()) {
      return;
    }

    generateVideo({
      prompt: prompt.trim(),
      model: 'default',
      duration: 5,
    });
  };

  if (showGuard) {
    return (
      <InteractionGuard
        onAuthenticated={() => {
          setShowGuard(false);
          handleGenerate();
        }}
        onCancel={() => setShowGuard(false)}
        actionName="generate videos"
      />
    );
  }

  return (
    <div className="min-h-full flex flex-col items-center justify-center py-12">
      <div className="fluid-container w-full">
        <h1 className="fluid-h2 font-bold text-white mb-6">Generate Video</h1>
        
        <div className="bg-white/5 border border-white/20 rounded-xl p-6 mb-6">
          <label className="block text-white mb-2">Prompt</label>
          <textarea
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            placeholder="Describe the video you want to generate..."
            className="w-full bg-black/50 border border-white/20 rounded-lg p-4 text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-white/50"
            rows={6}
          />
        </div>

        <button
          onClick={handleGenerate}
          disabled={loading || !prompt.trim()}
          className="w-full bg-white text-black py-3 rounded-lg font-semibold hover:bg-gray-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? 'Generating...' : 'Generate Video'}
        </button>

        {error && (
          <div className="mt-4 p-4 bg-red-500/20 border border-red-500/50 rounded-lg text-red-400">
            {error}
          </div>
        )}

        {result && (
          <div className="mt-4 p-4 bg-green-500/20 border border-green-500/50 rounded-lg text-green-400">
            Video generation started! Job ID: {(result as { job_id?: string; status?: string }).job_id}
            {(result as { job_id?: string; status?: string }).status && <div>Status: {(result as { job_id?: string; status?: string }).status}</div>}
          </div>
        )}
      </div>
    </div>
  );
}

